import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconBulletedList = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M7.33932 8.89275C7.55382 8.89275 7.72771 8.71886 7.72771 8.50436C7.72771 8.28986 7.55382 8.11597 7.33932 8.11597C7.12482 8.11597 6.95093 8.28986 6.95093 8.50436C6.95093 8.71886 7.12482 8.89275 7.33932 8.89275Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0581 8.50464H17.0492"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33932 12.3879C7.55382 12.3879 7.72771 12.214 7.72771 11.9995C7.72771 11.785 7.55382 11.6111 7.33932 11.6111C7.12482 11.6111 6.95093 11.785 6.95093 11.9995C6.95093 12.214 7.12482 12.3879 7.33932 12.3879Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0581 12H17.0492"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33932 15.8837C7.55382 15.8837 7.72771 15.7098 7.72771 15.4953C7.72771 15.2809 7.55382 15.1069 7.33932 15.1069C7.12482 15.1069 6.95093 15.2809 6.95093 15.4953C6.95093 15.7098 7.12482 15.8837 7.33932 15.8837Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0581 15.4958H17.0492"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconBulletedList.displayName = 'IconBulletedList';
